
class UrlEncoder {

    /**
     * 
     * Initializes URL Encoder Module
     * 
     * @param {String} api_key - API key for goo.gl URL shortener
     * 
     */
    constructor(api_key) {
        // Goo.Gl API key 
        this.api_key = api_key

        // this.domain = window.location.protocol + "//" + window.location.host + window.location.pathname
        this.domain = "https://techblogogy.github.io/garage48-vrideas/"
        this.domainSize = this.domain.length

        this.chunkSize = 2047 - this.domainSize
        this.splitExp = new RegExp(".{1,"+this.chunkSize+"}", "g")
    }

    /**
     * 
     * Function for generating short encoded URLs for data storage
     * 
     * @param {String} data - Data to encode and store 
     * 
     * @return {Promise} Base64 encoded string
     * 
     */
    encodeString(data) {

        this.chunks = this.getChunks(data)
        this.received = []

        return new Promise( (res, rej) => {
            if (this.chunks.length > 1) 
                this.getLoop(this.chunks[0], 0, res, rej)
            else
                this.getShort(this.chunks[0])
                .then (url => {
                    // return res("https://goo.gl/"+url)
                    return res(this.domain+"?data="+btoa(url))
                })
                .catch( err => {
                    return rej(err)
                } )
        } )

    }

    /**
     * 
     * Function for decoding data from Base64 string
     * 
     * @param {String} chunk - Base64 Encoded String 
     * 
     * @return {Promise} Decoded string with data
     * 
     */
    decodeString(chunk) {

        this.chunks = this.decodeChunks(chunk)
        this.received = []

        return new Promise( (res, rej) => {
            if (this.chunks[0].length === 6) {
                this.decodeLoop(this.chunks[0], 0, res, rej)
            } else {
                console.log(atob(chunk));
                return res(atob(chunk))
            }
        })
        
    }

    /**
     * 
     * Encodes Javascript Object as URL data parameter
     * 
     * @param {Object} json - Object with data
     * 
     * @return {Promise} Base64 Encoded String
     * 
     */
    encodeData(json){
        return this.encodeString(JSON.stringify(json))
    }

    /**
     * 
     * Recursive loop for encoding chunks of data
     * 
     * @param {String} chunk - Chunk Of Base64 Encoded String 
     * @param {Number} i - Index Of Current Chunk 
     * @param {function} res - Promise resolve function
     * @param {function} rej - Promise reject function 
     * 
     * @return {Promise} 
     * 
     */
    getLoop(chunk, i, res, rej) {

        this.getShort(chunk)
        .then( url => {
            this.received.push(url)
            console.log(this.received)

            if (i+1 < this.chunks.length) {
                this.getLoop(this.chunks[i+1], i+1, res, rej)
            } else {
                this.encodeString(this.received.join(","))
                .then ( res )
                .catch ( rej )
            }
        })
        .catch( rej )
    }

    /**
     * 
     * Recursive loop for decoding chunks of data
     * 
     * @param {String} Chunk Of goo.gl Encoded Data 
     * @param {Number} i - Index Of Current Chunk
     * @param {function} res - Promise resolve function
     * @param {function} rej - Promise reject function 
     * 
     * @return {Promise} 
     * 
     */
    decodeLoop(chunk, i, res, rej) {

        this.decodeShort(chunk)
        .then( url => {
            this.received.push(url)
            console.log(this.received)

            if (i+1 < this.chunks.length) {
                this.decodeLoop(this.chunks[i+1], i+1, res, rej)
            } else {
                this.decodeString(this.received.join(""))
                .then ( res )
                .catch ( rej )
            }
        })
        .catch( rej )
    }

    /**
     * 
     * Splits data string into chunks
     * 
     * @param {String} data 
     * 
     */
    getChunks (data) {
        const utf8String = unescape(encodeURIComponent(data)) 
        const dataBlob = btoa(utf8String)
        const blobChunks = dataBlob.match(this.splitExp)

        return blobChunks
    }

    /**
     * 
     * Decodes and splits Base64 chunks
     * 
     * @param {String} encChunks - returns normal data string
     * 
     */
    decodeChunks (encChunks) {
        const utf8String = escape(atob(encChunks))
        const data = decodeURIComponent(utf8String)
        const chunks = data.split(",")

        return chunks
    }

    /**
     * 
     * Encodes chunk as goo.gl URL
     * 
     * @param {String} chunk - Base64 Chunk
     * 
     */
    getShort(chunk) {

        return new Promise( (done, rej) => {

            fetch("https://www.googleapis.com/urlshortener/v1/url?key="+this.api_key, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify({ longUrl: this.domain+chunk })
            })
            .then ( res => res.json() )
            .then ( res => {
                const shortUrl = res.id.split("/")[3]
                return done(shortUrl)
            })
            .catch( err => {
                return rej(err);
            })
        })
        
    }

    /**
     * 
     * Decodes goo.gl data chunk 
     * 
     * @param {String} chunk  
     * 
     */
    decodeShort(chunk) {

        console.log(chunk)

        return new Promise( (done, rej) => {
            fetch("https://www.googleapis.com/urlshortener/v1/url?key="+this.api_key+"&shortUrl=https://goo.gl/"+chunk,)
            .then ( res => res.json() )
            .then ( res => {
                const longUrl = res.longUrl
                const urlCode = longUrl.replace(this.domain, "")

                return done(urlCode)
            })
            .catch( err => {
                return rej(err);
            })
        })
        
    }

    /**
     * 
     * Gets Parameter from URL
     * 
     * @param {*} name - parameter name
     * @param {*} url  - Domain URL
     * 
     */
    getParameterByName (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
}

export default UrlEncoder


// WEBPACK FOOTER //
// ./src/helpers/url-encoder.js